import formatDate from './formatDate';

const formatDeliveryDate = (date: Date): string => {
    const today = new Date(new Date().setUTCHours(0, 0, 0, 0));
    const dayDiff = Math.ceil(
        (date.getTime() - today.getTime()) / 1000 / 60 / 60 / 24
    );

    switch (dayDiff) {
        case 0:
            return 'Vandaag';
        case 1:
            return 'Morgen';
        case 2:
            return 'Overmorgen';
        default:
            return formatDate(date);
    }
};

export default formatDeliveryDate;
